// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__xUIOp","clinicsSelect":"TableHeading_clinicsSelect__9wJuB"};